import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import {
  Button, CircularProgress, Divider, Grid
} from "@material-ui/core";

import EditRoomForm from "../components/forms/EditRoomForm";

const styles = theme => ({
  progressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  saveRoomButton: {
    width: theme.spacing(16)
  }
});

class RoomEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      saving: false,
      editedRoom: {}
    };
  }

  setLoading(loading) {
    this.setState({ loading: loading });
  }

  setSaving(saving) {
    this.setState({ saving: saving });
  }

  componentDidMount() {
    this.setLoading(true);

    const finish = room => {
      this.setLoading(false);
      this.setState({ editedRoom: room.toJSON() });
    };

    this.props.rootStore.roomStore.fetchAndUpdate().then(() => {
      const room = this.props.rootStore.roomStore.rooms.get(this.props.id);

      if ((this.props.user || {}).is_staff) {
        this.props.rootStore.sensorGroupStore.fetchAndUpdate().then(() => {
          finish(room);
        });
      } else {
        finish(room);
      }
    });
  }

  render() {
    const classes = this.props.classes;

    const room = this.props.rootStore.roomStore.rooms.get(this.props.id);

    if (this.state.loading) {
      return (
        <div className={classes.progressContainer}>
          <CircularProgress className={classes.progress} />
        </div>
      );
    }

    return (
      <>

        <EditRoomForm room={ room } notifications={ this.props.rootStore.notificationStore } />

        <br />
        <Divider />
        <br />

        <Grid container spacing={2} justify="center" >
          <Grid item>
            <Button variant="contained" color="secondary" onClick={ () => room.downloadJson() }>
                Export Data (JSON)
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="secondary" onClick={ () => room.downloadCsv() }>
                Export Data (CSV)
            </Button>
          </Grid>
        </Grid>

      </>
    );
  }
}

export default withStyles(styles)(
  inject(stores => ({
    user: stores.rootStore.authStore.user,
    rootStore: stores.rootStore
  }))(observer(RoomEdit))
);
